import {
  workspaceSearchSchema,
  type WorkspaceSearch,
} from "./workspace-search";

const STORAGE_KEY_PREFIX = "saile.providerWorkspace.lastSearch";

function storageKey(organizationBusinessUnitId: string) {
  return `${STORAGE_KEY_PREFIX}:${organizationBusinessUnitId}`;
}

/** Remembers the roster's filters so the provider page can link back to the
 * same filtered view. Storage can be unavailable; the roster still works. */
export function saveLastWorkspaceSearch({
  organizationBusinessUnitId,
  search,
}: {
  organizationBusinessUnitId: string;
  search: WorkspaceSearch;
}) {
  try {
    window.sessionStorage.setItem(
      storageKey(organizationBusinessUnitId),
      JSON.stringify(search),
    );
  } catch {
    // The page falls back to the unfiltered roster.
  }
}

export function readLastWorkspaceSearch(
  organizationBusinessUnitId: string,
): WorkspaceSearch {
  try {
    const stored = window.sessionStorage.getItem(
      storageKey(organizationBusinessUnitId),
    );
    const parsed = workspaceSearchSchema.safeParse(
      stored ? JSON.parse(stored) : {},
    );
    return parsed.success ? { ...parsed.data, provider: undefined } : {};
  } catch {
    return {};
  }
}
